<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />
    <h3 class="mb-7">Kita informacija</h3>

    <div class="dataContainer">
      <v-row>
        <v-col cols="12" v-if="showNustatymoPagrindas">
          <el-textarea
            need
            :label="tekstas.nustatymo_pagrindas"
            :tooltip="tekstas.nustatymo_pagrindasTooltip"
            :counter="2000"
            :readonly="isReadonlyForm"
            v-model="formData.obj_kita_nustatymo_pagrindas"
            autofocus
          />
        </v-col>
        <v-col cols="12">
          <el-textarea
            :label="tekstas.palukanu_aprasymas"
            :tooltip="tekstas.palukanu_aprasymasTooltip"
            :counter="2000"
            :readonly="isReadonlyForm"
            v-model="formData.obj_kita_palukanu_aprasymas"
            :autofocus="!showNustatymoPagrindas"
          />
        </v-col>
        <v-col cols="12" md="4">
          <el-money-field
            :label="tekstas.palukanos"
            :tooltip="tekstas.palukanosTooltip"
            :readonly="isReadonlyForm"
            v-model="formData.obj_kita_palukanos"
          />
        </v-col>

        <v-col cols="12" v-if="showVarzytiniuEile">
          <el-textarea
            :label="tekstas.varzytiniu_eile"
            :tooltip="tekstas.varzytiniu_eileTooltip"
            :counter="4000"
            :readonly="isReadonlyForm"
            v-model="formData.obj_kita_varzytiniu_eile"
          >
            <template v-if="!isReadonlyForm" slot="append-outer">
              <el-button
                class="textarea-button"
                @click.native="addTurtasConfirm()"
                :loading="turtasLoading"
              >
                Pildyti įvestų turtų duomenimis
              </el-button>
            </template>
          </el-textarea>
        </v-col>
        <v-col cols="12" v-if="showIsigaliojimoMomentas">
          <el-textarea
            :label="tekstas.isigaliojimo_momentas"
            :tooltip="isigaliojimoMomentasTooltip"
            :counter="2000"
            :readonly="readonlyIsigaliojimoMomentas"
            v-model="formData.obj_kita_isigaliojimo_momentas"
          />
        </v-col>
        <v-col cols="12" v-if="showReikalavimoTerminas">
          <el-textarea
            :label="tekstas.reikalavimo_terminas"
            :tooltip="tekstas.reikalavimo_terminasTooltip"
            :counter="2000"
            :readonly="isReadonlyForm"
            v-model="formData.obj_kita_reikalavimo_terminas"
          />
        </v-col>
        <v-col cols="12" v-if="showKitiSandoriai">
          <el-textarea
            :label="tekstas.kiti_sandoriai"
            :tooltip="kitiSandoriaiTooltip"
            :counter="2000"
            :readonly="isReadonlyForm"
            v-model="formData.obj_kita_kiti_sandoriai"
          >
            <template
              slot="append-outer"
              v-if="!isReadonlyForm && !isSavitarna"
            >
              <el-button
                class="textarea-button"
                @click.native="addSandorisConfirm()"
                :loading="sandorisLoading"
              >
                Pildyti kitus sandorius
              </el-button>
            </template>
          </el-textarea>
        </v-col>
        <v-col cols="12" v-if="showPerduodamas">
          <el-checkbox
            class="mb-4"
            :label="tekstas.perduodamas_kreditoriui"
            :tooltip="tekstas.perduodamas_kreditoriuiTooltip"
            :readonly="isReadonlyForm"
            v-model="perduodamasKreditoriui"
            @click.native="changePerduodamasKreditoriui()"
          />
        </v-col>
      </v-row>
    </div>
    <hipoteka-istorija duomenys="kitainformacija" />

    <modal-confirm
      :title="confirmTitle"
      :text="confirmText"
      :action="confirmAction"
      v-model="showConfirm"
      @confirmAddTurtas="addTurtas"
      @confirmAddSandoris="addSandoris"
    />

    <v-footer class="form-footer">
      <el-button
        v-if="!isReadonlyForm"
        primary
        @click.native="saveData()"
        :loading="loading"
        >Saugoti</el-button
      >
      <el-button
        v-if="!isReadonlyForm"
        @click.native="cancelData()"
        :loading="loading"
        >Atšaukti</el-button
      >
      <v-spacer></v-spacer>
      <el-button
        v-if="!isReadonlyForm"
        primary
        @click.native="checkErrorsClick()"
        :loading="loading"
        >Tikrinti</el-button
      >
    </v-footer>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import HipotekaMap from './hipotekaMap'
import unsavedData from '../../mixins/unsavedData'
import checkErrors from '../../mixins/checkErrors'
import HipotekaIstorija from './istorija/HipotekaIstorija'
import ModalConfirm from '../modals/ModalConfirm'

export default {
  name: 'HipotekaKitaInfo',
  components: {
    HipotekaIstorija,
    ModalConfirm,
  },
  mixins: [unsavedData, checkErrors],
  $_veeValidate: {
    validator: 'new',
  },
  props: {
    readonlyForm: { type: Boolean, default: false },
  },
  data() {
    return {
      formData: {},
      obj_rusys: {},
      palukanos: null,
      kita_informacija: null,
      loading: true,
      pageloading: true,
      turtasLoading: false,
      sandorisLoading: false,
      showConfirm: false,
      confirmTitle: null,
      confirmText: null,
      confirmAction: null,
      perduodamasKreditoriui: false,
    }
  },
  computed: {
    ...mapGetters([
      'objektasID',
      'hipotekaTipas',
      'objektasVeiksmas',
      'hipotekaReadonly',
      'appSavitarna',
    ]),
    isSavitarna() {
      return this.appSavitarna
    },
    isReadonlyForm() {
      return this.hipotekaReadonly || this.readonlyForm
    },
    tekstas() {
      const key = Object.keys(HipotekaMap['kitaInfoTekstas']).find(e =>
        this.hipotekaTipas.includes(e)
      )
      return key ? HipotekaMap['kitaInfoTekstas'][key] : {}
    },
    salyginis() {
      return this.obj_rusys.salyginis
    },
    showPerduodamas() {
      return (
        !this.isSavitarna && this.hipotekaTipas.includes('sutartinis-ikeitimas')
      )
    },
    isPriverstinis() {
      return this.hipotekaTipas.includes('priverstinis')
    },
    isSutartinis() {
      return this.hipotekaTipas.includes('sutartinis')
    },
    isSudarymas() {
      return this.objektasVeiksmas === 1
    },
    isTeikimas() {
      return this.objektasVeiksmas === 2
    },
    showVarzytiniuEile() {
      return !this.isPriverstinis && !this.isSavitarna
    },
    showIsigaliojimoMomentas() {
      return !this.isPriverstinis
    },
    readonlyIsigaliojimoMomentas() {
      return this.isReadonlyForm || (this.isSavitarna && this.isSudarymas)
    },
    isigaliojimoMomentasTooltip() {
      return this.isSavitarna && this.isSudarymas
        ? 'Hipoteka. Kita info. Sutartinis įkeitimas. Įsigaliojimo momentas. Savitarna. Sudarymas'
        : this.tekstas.isigaliojimo_momentasTooltip
    },
    showReikalavimoTerminas() {
      return !this.isSutartinis
    },
    showKitiSandoriai() {
      return !this.isPriverstinis
    },
    kitiSandoriaiTooltip() {
      return `${this.isSavitarna ? 'Savitarna. ' : ''}${
        this.tekstas.kiti_sandoriaiTooltip
      }`
    },
    showNustatymoPagrindas() {
      return this.isPriverstinis
    },
  },
  created() {
    this.getData()
  },

  methods: {
    getData() {
      this.pageloading = true
      this.loading = true

      this.$axios
        .get(`objektas/${this.objektasID}/kitainformacija`)
        .then(res => {
          this.formData = res.data.kita_informacija
          this.obj_rusys = res.data.obj_rusys
          this.perduodamasKreditoriui =
            this.formData.obj_kita_perduodamas_kreditoriui > 0 ? true : false
          this.initialForm()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
          this.$validator.reset()
        })
    },
    saveData(toRoute, afterSave) {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.loading = true
          let data = this.formData
          data.obj_id = this.objektasID

          this.$axios
            .post(`objektas/${this.objektasID}/kitainformacija`, data)
            .then(res => {
              window._VMA.$emit('DATA_OK', 'Duomenys išsaugoti')

              if (toRoute) {
                this.goToRoute()
              } else {
                this.initialForm()
                if (afterSave === 'checkErrors') {
                  this.checkErrors()
                }
              }
            })
            .catch(err => {
              window._VMA.$emit('DATA_ERROR', err.response.data.message)
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          window._VMA.$emit('FORMAT_ERROR')
          this.$root.$emit('cancelTabNavigation')
        }
      })
    },
    cancelData() {
      this.getData()
    },
    addTurtasConfirm() {
      this.confirmTitle = 'Pildyti įvestų turtų duomenimis'
      this.confirmText =
        'Duomenys bus atnaujinti ir įrašyti vietoje šiame lauke įvestų duomenų. Ar norite tęsti?'
      this.confirmAction = 'AddTurtas'
      this.showConfirm = true
    },
    addTurtas() {
      this.turtasLoading = true

      this.$axios
        .get(`objektas/${this.objektasID}/kitainformacija/turtas`)
        .then(res => {
          this.formData.obj_kita_varzytiniu_eile = this.parseTurtas(
            this.formData.obj_kita_varzytiniu_eile,
            res.data.turtai
          )
          window._VMA.$emit('DATA_OK', res.data.message)
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.turtasLoading = false
        })
    },
    addSandorisConfirm() {
      this.confirmTitle = 'Pildyti kitus sandorius'
      this.confirmText =
        'Duomenys bus atnaujinti ir įrašyti vietoje šiame lauke įvestų duomenų. Ar norite tęsti?'
      this.confirmAction = 'AddSandoris'
      this.showConfirm = true
    },
    addSandoris() {
      this.sandorisLoading = true

      this.$axios
        .get(`objektas/${this.objektasID}/kitainformacija/sandoriai`)
        .then(res => {
          this.formData.obj_kita_kiti_sandoriai = this.parseSandoris(
            this.formData.obj_kita_kiti_sandoriai,
            res.data.sandoriai
          )
          window._VMA.$emit('DATA_OK', res.data.message)
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.sandorisLoading = false
        })
    },
    parseTurtas(oldText, newText) {
      return (
        // (oldText && oldText.length > 0
        //   ? oldText + (newText && newText.length > 0 ? '\n' : '')
        //   : '') +
        newText
          .map(item => {
            return `${item.eil_nr}. ${
              item.tur_identifikatorius ? item.tur_identifikatorius + ', ' : ''
            }${item.trs_pavadinimas}, ${
              item.kita_informacija
                ? item.kita_informacija.replace(/(.{130})..+/, '$1...')
                : ''
            }`
          })
          .join('\n')
      )
    },
    parseSandoris(oldText, newText) {
      return (
        // (oldText && oldText.length > 0
        // ? oldText + (newText && newText.length > 0 ? '\n' : '')
        // : '') +
        newText.join('\n')
      )
    },
    checkErrorsClick() {
      this.saveData(null, 'checkErrors')
    },
    changePerduodamasKreditoriui() {
      this.formData.obj_kita_perduodamas_kreditoriui = this
        .perduodamasKreditoriui
        ? 1
        : 0
    },
  },
}
</script>
<style lang="scss" scoped>
.textarea-button {
  top: -11px;
}
.dataContainer {
  max-width: 1000px;
}
</style>
